/**
 * @file コンポーネント：ノートドロワー ロジック管理
 */

// ライブラリ読み込み
import React, { useEffect, useRef, useState } from "react";

// 関数読み込み
import { fnSetFixedBody } from "~/src/functions/common";

// Presenter読み込み
import { Presenter } from "./presenter";

// コンポーネントを返す
export const DrawerNote = (props) => {
    /**
     * ドロワーの高さ調整処理
     */
    const refDrawer = useRef(null); // ドロワー要素
    const [drawerHeight, setDrawerHeight] = useState(null); // ドロワーの高さ
    const [startY, setStartY] = useState(null); // 処理前のY座標
    const [endY, setEndY] = useState(null); // 処理後のY座標
    // タッチ開始時の処理（タッチデバイスの場合のみ）
    const fnOnTouchStart = (e) => {
        fnSetFixedBody(true);
        setStartY(e.touches[0].clientY);
        setDrawerHeight(refDrawer.current.getBoundingClientRect().height);
    };
    // タッチ中の処理（タッチデバイスの場合のみ）
    const fnOnTouchMove = (e) => {
        setEndY(e.changedTouches[0].clientY);
    };
    // タッチ完了時の処理（タッチデバイスの場合のみ）
    const fnOnTouchEnd = () => {
        fnSetFixedBody(false);
    };
    // ドラッグ開始時の処理（非タッチデバイスの場合のみ）
    const [isDrag, setIsDrag] = useState(false); // ドラッグ状態
    const fnOnMouseDown = (e) => {
        setIsDrag(true);
        setStartY(e.pageY);
        setDrawerHeight(refDrawer.current.getBoundingClientRect().height);
        document.body.addEventListener(
            "mouseup",
            () => {
                fnOnMouseUp();
            },
            { once: true }
        );
    };
    // ドラッグ中の処理（非タッチデバイスの場合のみ）
    const fnOnMouseMove = (e) => {
        if (isDrag === true) {
            setEndY(e.pageY);
        }
    };
    // ドラッグ完了時の処理（非タッチデバイスの場合のみ）
    const fnOnMouseUp = () => {
        setIsDrag(false);
    };
    // 処理後のY座標更新時に高さを随時更新する
    useEffect(() => {
        if (endY !== null) {
            refDrawer.current.style.height =
                drawerHeight - (endY - startY) + "px";
        }
    }, [endY]);

    // Presenterに渡す
    return (
        <Presenter
            {...props}
            fnOnMouseDown={fnOnMouseDown}
            fnOnMouseMove={fnOnMouseMove}
            fnOnTouchEnd={fnOnTouchEnd}
            fnOnTouchMove={fnOnTouchMove}
            fnOnTouchStart={fnOnTouchStart}
            isDrag={isDrag}
            refDrawer={refDrawer}
            setIsDrag={setIsDrag}
        />
    );
};
